import { ContentItem } from '../../types/types'

export const briefContent: Array<ContentItem> = [
  {
    key: '1',
    question: 'Что такое онигири?',
    answer: 'Онигири, они же омусуби или нигиримэси — это очень популярное блюдо японской кухни. Они имеют вид треугольников или шариков из пресного риса с начинкой внутри, обёрнуты чаще всего водорослями нори. Онигири очень простые, сытные, вкусные и удобные. Их кушают везде: дома, на работе, в гостях, ресторанах и не только.'
  },
  {
    key: '2',
    question: 'Их сложно делать?',
    answer: 'Онигири очень просто готовить. Это потому, что в них нет сложных начинок, нет запекания, жарки и другого. Их просто лепят из варёного риса определенной техникой. И всё.'
  },
  {
    key: '3',
    question: 'Сколько стоит порция?',
    answer: 'Самые простые онигири «Магуро» из риса, майонеза, тунца и нори обойдутся в среднем от 200 рублей, если вам нужно докупить лишь тунец и нори, порции хватит на двоих взрослых. Итоговая стоимость блюда сильно зависит от того, какую начинку-морепродукт вы положите внутрь: с тунцом дешевле, с форелью или креветками сильно дороже.'
  },
  {
    key: '4',
    question: 'Онигири долго готовить?',
    answer: 'Лепка треугольников или шариков занимает от 10 минут, всё зависит от опыта. Если учитывать варку риса и подготовку начинки, то готовить суммарно от 30 минут - максимум час с перерывами на остужение риса и другие мелочи.'
  },
  {
    key: '5',
    question: 'Это перекус или сытное?',
    answer: 'Онигири можно рассматривать как угодно: ими легко пообедать или съесть на ужин, будет очень сытно, а можно взять немного в дорогу, как перекус. Чтобы почувствовать сытость, хватит около трёх-пяти онигири стандартного размера, в порции получается порядка 8-10 (если следовать рецептам ниже).'
  }
]
